"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DeveloperPostViewNavigation_1 = __importDefault(require("./DeveloperPostViewNavigation"));
var filters_1 = require("../../../helpers/filters");
var DeveloperPostSections_1 = __importDefault(require("./DeveloperPostSections"));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var DeveloperPostContent = function (_a) {
    var currentTab = _a.currentTab, postData = _a.postData, handleSelectTab = _a.handleSelectTab, setPostMedia = _a.setPostMedia, handleScrollToShowMobileMedias = _a.handleScrollToShowMobileMedias, isMortgageButtonClicked = _a.isMortgageButtonClicked, setIsMortgageButtonClicked = _a.setIsMortgageButtonClicked, setApartmentsTablePositionY = _a.setApartmentsTablePositionY, setIsRelatedPostClicked = _a.setIsRelatedPostClicked, isRelatedPostClicked = _a.isRelatedPostClicked;
    var hasAvailablePost = react_1.useMemo(function () { return filters_1.hasAvailableFreePost(postData.sections.apartment_info); }, [postData.sections.apartment_info]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DeveloperPostViewNavigation_1.default, { currentTab: currentTab, handleSelectTab: handleSelectTab, hasAvailablePost: hasAvailablePost, propertyType: postData.propertyType, isRent: postData.deal === GeneralSettings_1.DEAL_TYPES.RENT }),
        react_1.default.createElement(DeveloperPostSections_1.default, { postData: postData, currentTab: currentTab, handleSelectTab: handleSelectTab, setPostMedia: setPostMedia, handleScrollToShowMobileMedias: handleScrollToShowMobileMedias, isMortgageButtonClicked: isMortgageButtonClicked, setIsMortgageButtonClicked: setIsMortgageButtonClicked, setApartmentsTablePositionY: setApartmentsTablePositionY, isRent: postData.deal === GeneralSettings_1.DEAL_TYPES.RENT, setIsRelatedPostClicked: setIsRelatedPostClicked, isRelatedPostClicked: isRelatedPostClicked })));
};
exports.default = DeveloperPostContent;
